import { spawn } from 'redux-saga/effects';

import profileSagas from './profile/profileSagas';

export default function* sagas() {
	yield spawn(profileSagas);
}
